/* eslint-disable react/prop-types */
/* eslint-disable  react/no-array-index-key */
/* eslint-disable  jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Modal } from 'react-bootstrap';
import './SsrSelectionStyles.scss';
import AppButton from '../../shared/components/app-button/AppButton';
import { formatCurrency } from '../../shared/helper-utils/appUtils';

export default function SpecialSsrSelectionComponent({
  showSpecialSsr,
  setShowSpecialSsr,
  flightLegsWithSpecialSsr,
  handleAddSpecialSsr,
  specialSsrSelectionSector,
  setSpecialSsrSelectionSector,
  userSelectedSsrRows,
  travellers,
  activeSsrIndex,
  setActiveSsrIndex,
  getSelectedSpecailSsr,
  handleRemoveSpecialSsr,
  isNormalBooking = true,
}) {
  const getByName = (userBaggageRows) => {
    return userBaggageRows.reduce((acc, cur) => {
      if (acc[cur.fullName]) {
        acc[cur.fullName].push(cur);
      } else {
        acc[cur.fullName] = [cur];
      }
      return acc;
    }, {});
  };
  return (
    <Modal
      className="app-modal priority-checkin-modal"
      size="lg"
      show={showSpecialSsr}
      onHide={() => setShowSpecialSsr(false)}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Special SSR</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="separator" />
        <div className="baggage-sectors-row d-flex">
          {Object.keys(flightLegsWithSpecialSsr).length === 0 && (
            <div className="fs-14 text-center flex-1">
              Currently Special SSR is not available
            </div>
          )}
          {Object.keys(flightLegsWithSpecialSsr).map((sector) => (
            <div
              key={sector}
              className={`baggage-sector ${
                specialSsrSelectionSector === sector
                  ? 'active-baggage-sector'
                  : ''
              }`}
              onClick={() => setSpecialSsrSelectionSector(sector)}
            >
              {sector}
            </div>
          ))}
        </div>
        <div className="separator" />
        {Object.keys(flightLegsWithSpecialSsr).map((sector) => {
          const allSpecialSsr = flightLegsWithSpecialSsr[sector];
          const userSpecialSsrRows =
            userSelectedSsrRows[sector]?.specialSsrRows || [];
          let byName;
          if (!isNormalBooking) {
            byName = getByName(userSpecialSsrRows);
          }
          return (
            specialSsrSelectionSector === sector && (
              <div key={sector}>
                <div className="d-flex p-3 travellers-info">
                  {isNormalBooking ? (
                    <>
                      {travellers.map(
                        (traveller, index) =>
                          traveller.type.toLowerCase() !== 'infant' && (
                            <div
                              className={`traveller-name ${
                                activeSsrIndex === index && 'active-traveller'
                              }`}
                              key={index}
                              onClick={() => setActiveSsrIndex(index)}
                            >
                              {traveller.first_name !== ''
                                ? `${traveller.title} ${traveller.first_name} ${traveller.last_name}`
                                : `Traveller ${index + 1}`}
                              <small className="traveller-name__subheading">
                                {getSelectedSpecailSsr(
                                  userSpecialSsrRows,
                                  index,
                                )}
                              </small>
                            </div>
                          ),
                      )}
                    </>
                  ) : (
                    <>
                      {Object.keys(byName).map(
                        (fullName, index) =>
                          byName[fullName][0].paxtype.toLowerCase() !==
                            'infant' && (
                            <div
                              className={`traveller-name ${
                                activeSsrIndex === index && 'active-traveller'
                              }`}
                              key={index}
                              onClick={() => setActiveSsrIndex(index)}
                            >
                              {fullName}
                              <small className="traveller-name__subheading">
                                {getSelectedSpecailSsr(
                                  byName[fullName],
                                  index,
                                  sector,
                                )}
                              </small>
                            </div>
                          ),
                      )}
                    </>
                  )}
                </div>
                <div className="separator" />
                <div className="d-flex flex-wrap justify-content-between p-3">
                  {allSpecialSsr.map((specialSsr, index) => (
                    <div
                      key={`${specialSsr.ssrcode}_${index}`}
                      className="ssr-card p-2 mb-2"
                    >
                      <div>
                        <img
                          className="meal-image"
                          src={specialSsr.imageurl}
                          alt={specialSsr.ssrname}
                        />
                      </div>
                      <div className="ps-3 pe-3 w-100 d-flex flex-column">
                        <div className="flex-1">
                          <p className="ssr-card__meal-name">
                            {specialSsr.ssrname}
                          </p>
                          <p className="ssr-card__meal-description">
                            {specialSsr.Desc}
                          </p>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="ssr-card__meal-name">
                            {formatCurrency(specialSsr.chargeableamount)}
                          </p>
                          {userSpecialSsrRows[activeSsrIndex].hasSsr ? (
                            ''
                          ) : (
                            <>
                              {userSpecialSsrRows[activeSsrIndex].ssrcode ===
                              specialSsr.ssrcode ? (
                                <AppButton
                                  variant="outlined"
                                  className="ssr-card__add-btn"
                                  btnText="Remove"
                                  onClick={() =>
                                    handleRemoveSpecialSsr(
                                      specialSsr,
                                      activeSsrIndex,
                                      `${specialSsr.origin} - ${specialSsr.destination}`,
                                    )
                                  }
                                />
                              ) : (
                                <AppButton
                                  className="ssr-card__add-btn"
                                  btnText="Add"
                                  onClick={() =>
                                    handleAddSpecialSsr(specialSsr, sector)
                                  }
                                />
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )
          );
        })}
      </Modal.Body>
      <Modal.Footer>
        <AppButton
          onClick={() => setShowSpecialSsr(false)}
          btnText="Continue"
          variant="outlined"
        />
      </Modal.Footer>
    </Modal>
  );
}
